import { render, staticRenderFns } from "./drafts.pug?vue&type=template&id=ff7c025a&lang=pug&"
import script from "./drafts.ts?vue&type=script&lang=ts&"
export * from "./drafts.ts?vue&type=script&lang=ts&"
import style0 from "./drafts.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports